<template>
    <!-- Modal para crear o editar nombre de carpeta -->
    <b-modal v-model="modal_name.show"
             centered
             :title="modal_name.creating ? 'Crear carpeta' : 'Editar nombre'"
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="folder"
        >
            <b-row>
                <!-- Campo para ingresar el nombre -->
                <b-col cols="12"
                       class="mb-2"
                >
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <!-- Input para el nombre de la carpeta -->
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  type="text"
                                  class="text-uppercase-input"
                                  v-model="folder.original_name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:150'"
                        />
                        <!-- Mensaje de error en caso de validación fallida -->
                        <span class="text-danger small"
                              v-text="errors.first('folder.original_name')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-center"
                    >
                        <!-- Botón para guardar los cambios -->
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <!-- Botón para cancelar la operación -->
                        <b-button @click="setShowToModalName(false)"
                                  variant="secondary"
                                  class="ml-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal_name',
    computed: {
        ...mapState('calculator', [
            'modal_name',
            'folder'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getManufacturers',
            'createProduct',
            'updateProduct',
            'createFolder',
            'updateName'
        ]),
        ...mapMutations('calculator', [
            'setShowToModalName'
        ]),
        /**
         * Válida el formulario de creación o edición de nombre de carpeta.
         * Si la validación es exitosa, realiza la acción correspondiente (crear o actualizar).
         */
        validateForm() {
            this.$validator.validateAll('folder')
                .then(async (result) => {
                    if (result) {
                        const company_id = this.$route.params.company_id;
                        if (this.modal_name.creating) {
                            await this.createFolder(company_id);
                        } else {
                            await this.updateName(company_id);
                        }
                        this.$emit('list');
                    }
                });
        }
    }
};
</script>

<style scoped>
.text-uppercase-input input {
    text-transform: uppercase;
}
</style>
